export function clamp(v: number, min: number, max: number)
{
    return Math.max(Math.min(v, max), min);
}
